import { app } from "@app/appLauncher";
import { getTool } from "@app/internal/supportToolsList/toolsList";
import FindLeadDuplicatesPage from "@app/tools/leads/findLeadDuplicates/findLeadDuplicatesPage";

app(<FindLeadDuplicatesPage tool={getTool("find-lead-duplicates")} />);
